<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="itemProductsService"
    [idKey]="'itemProductId'"
></base-index-page>